import { render, staticRenderFns } from "./EthGasPrices.vue?vue&type=template&id=a3bd12f0&scoped=true&"
import script from "./EthGasPrices.vue?vue&type=script&lang=js&"
export * from "./EthGasPrices.vue?vue&type=script&lang=js&"
import style0 from "./EthGasPrices.vue?vue&type=style&index=0&id=a3bd12f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bd12f0",
  null
  
)

export default component.exports